/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { useTranslation } from 'react-i18next';
 
import { Form } from 'react-bootstrap';
import styles from '../styles/languageswitcher.module.scss'
import { CountryData } from '../store/interfaces';
import { getCountry } from '../i18n';

interface LanguageSwitcherProps {
    black?: boolean;
    lineBreak?: boolean;
    disableCountryChange?: boolean;
    country: CountryData;
    onUiSetCountry: (country: CountryData) => void;
    onUiShowCountryChangeInfo: (showCountryChangeInfo: boolean) => void;
}

export function LanguageSwitcher(props:LanguageSwitcherProps) {
    const {i18n} = useTranslation();
    return (
        <div className={`d-flex align-items-center ${styles.container}`}>
            <Form.Select className={styles.country} aria-label="" disabled={props.disableCountryChange} data-testid="mymotion_countrySwitcher" onChange={(evt) => {
                if(props.disableCountryChange === true) {
                    return;
                }
                // Todo(daniel): Create common list of countries and only set by id.
                if(evt.target.value === 'de') {
                    props.onUiSetCountry({
                        id: 'de',
                        currency: 'eur',
                        vat: 0.19
                    });
                } else if(evt.target.value === 'at') {
                    props.onUiSetCountry({
                        id: 'at',
                        currency: 'eur',
                        vat: 0.2
                    });
                } else if(evt.target.value === 'ch') {
                    // props.onUiSetCountry({
                    //     id: 'ch',
                    //     currency: 'chf',
                    //     vat: 0.077
                    // });
                }
            }} value={props.country.id}>
                <option value='de'>{getCountry('DE', i18n.language)}</option>
                <option value='at'>{getCountry('AT', i18n.language)}</option>
                {/*<option value='ch'>{getCountry('CH', i18n.language)}</option>*/}
            </Form.Select>
            {!props.lineBreak && <span className={styles.footerSeparator}></span>}
            <button data-testid="mymotion_languageSwitcher" className={`${styles.languageLink} ${i18n.language === 'de' ? styles.selected : ''} ${props.black ? styles.black : ''}`} onClick={() => {i18n.changeLanguage('de')}}>DE</button>
            <button data-testid="mymotion_languageSwitcher" className={`${styles.languageLink} ${i18n.language === 'en' ? styles.selected : ''} ${props.black ? styles.black : ''}`} onClick={() => {i18n.changeLanguage('en')}}>EN</button>
            <button data-testid="mymotion_languageSwitcher" className={`${styles.languageLink} ${i18n.language === 'fr' ? styles.selected : ''} ${props.black ? styles.black : ''}`} onClick={() => {i18n.changeLanguage('fr')}}>FR</button>
{/*             <button className={`${styles.languageLink} ${i18n.language === 'DEV' ? styles.selected : ''} ${props.black ? styles.black : ''}`} onClick={() => {i18n.changeLanguage('dev')}}>DEV</button>
 */}        </div>
    );
};
 